/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_DonateInputs */

const en_header_donate = /** @type {(inputs: Header_DonateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate`)
};

/**
* | output |
* | --- |
* | "Donate" |
*
* @param {Header_DonateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_donate = /** @type {((inputs?: Header_DonateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_DonateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_donate(inputs)
});